import VxeCheckboxComponent from './src/checkbox';
import { dynamicApp } from '../dynamics';
export var VxeCheckbox = Object.assign(VxeCheckboxComponent, {
    install: function (app) {
        app.component(VxeCheckboxComponent.name, VxeCheckboxComponent);
    }
});
export var Checkbox = VxeCheckbox;
dynamicApp.component(VxeCheckboxComponent.name, VxeCheckboxComponent);
export default VxeCheckbox;
